<template>
    <div class="row">
      <div
        v-if="!open && calendar.days.length > 0"
        :class="day ? 'col-lg-8' : 'col-lg-8'"
      >
        <table class="mt-4 w-100">
          <thead>
            <tr>
              <td style="width:14%;" v-for="day in calendar.labeldays">
                <div class="text-center">
                  <small class="text-center text-uppercase text-secondary">{{
                    $t("lang.label." + day)
                  }}</small>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="(i, k) in [0, 1, 2, 3, 4, 5, 6]">
                <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
              </td>
            </tr>
            <tr>
              <td v-for="(i, k) in [7, 8, 9, 10, 11, 12, 13]">
                <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
              </td>
            </tr>
            <tr>
              <td v-for="(i, k) in [14, 15, 16, 17, 18, 19, 20]">
                <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
              </td>
            </tr>
            <tr>
              <td v-for="(i, k) in [21, 22, 23, 24, 25, 26, 27]">
                <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
              </td>
            </tr>
            <tr>
              <td v-for="(i, k) in [28, 29, 30, 31, 32, 33, 34]">
                <Day :i="i" :nodays="nodays" :calendar="calendar" :day="day" @showDay="showDay($event)"></Day>
              </td>
            </tr>
            <tr>
              <td v-for="(i, k) in [35, 36, 37, 38, 39, 40, 41]">
                <div class="pt-2 text-center text-secondary">
                  <span v-if="calendar.days[i] == 1">{{ i + 1 - nodays }}</span>
                  <span
                    v-if="day == i + 1 - nodays"
                    class="cursor-pointer bg-secondary text-white rounded-circle"
                    style="width:40px;height:40px;padding-top:8px;"
                    >{{ i + 1 - nodays }}</span
                  >
                  <span
                    v-if="calendar.days[i] == 2 && day != i + 1 - nodays"
                    :class="
                      calendar.days[i] == 2
                        ? 'cursor-pointer bg-primary text-white rounded-circle'
                        : ''
                    "
                    style="width:40px;height:40px;padding-top:8px;"
                    @click="showDay(i + 1 - nodays)"
                    >{{ i + 1 - nodays }}</span
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <Modal :name="'noSlotsAvailable'" size="30">
          <div class="p-4 text-center">
            <label>
              <h4>{{ $t('lang.calendar.noslotsavailablethismonth',{'month': $t("lang.label." + monthlabel )}) }}</h4>
            </label>
            <a class="text-primary m-2 border p-3 rounded" type="button" @click="goToNextMonth()">
              {{ $t("lang.calendar.seenextmonth") }}
              <i class="icon-arrow-right"></i>
            </a>
          </div>
  
  
        </Modal>
      </div>
  
      <div class="col-lg-4">
        <div v-if="loadingHourly">
          <span
            class="loadingres d-flex p-2 spinner-border loading-spinner mx-auto"
          >
          </span>
        </div>
        <span v-if="hourly.length == 0 && !loadingHourly" class="card p-2">
          <span class="d-inline">{{$t('lang.calendar.notavailable')}}</span>
        </span>
        <CalendarHourly
          v-if="!loadingHourly && hourly && !open"
          @open="openForm($event)"
          :hours="hourly"
        ></CalendarHourly>
  
      </div>
      <div class="col-md-12">
        <div class="row mt-3">
          <div class="col-md-9" v-if="!open">
            <i class="icon-globe"></i> {{ $t("lang.calendar.timezone") }}
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="row mt-3">
          <div class="col-md-9" v-if="!open">
            <select
              v-model="timezone"
              @change="selectTimeZone()"
              class="form-control w-100"
            >
              <option value="false" v-if="!timezone" selected>
                {{ $t("lang.label.choose") }}
              </option>
              <option
                v-for="(lang, i) in timezones"
                :key="`Lang${i}`"
                :value="lang.id"
              >
                {{ lang.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="open" class="col-md-12">
        <div class="mt-3">
          <vue-form-generator
            ref="schemaStatusV"
            :key="calendarFormKey"
            :schema="schemaStatus"
            :model="modelform"
            :options="formOptions"
          ></vue-form-generator>
          <div class="col-md-12">
            <button class="btn btn-primary" @click="createEvent()">
              {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import { mapState, mapActions } from "vuex";
  import CalendarHourly from "@/components/Calendar/CalendarHourly.vue";
  import Day from "@/components/Calendar/Day.vue";
  import VueFormGenerator from "vue-form-generator";
  import Modal from "@/components/Common/Modal.vue";
  import { myCalendarService } from "@/_services";

  export default {
    data() {
      return {
        countries: [],
        countryNames: ['France'],
        myhs:false,
        myhsdefault:false,
        isEmail: false,
        timezone: false,
        business_contact_hash: false,
        campaign_hash: false,
        hourchoose: false,
        open: false,
        nodays: 0,
        slotsAvailable: false,
        day: false,
        loadingHourly: false,
        modelform: {
          first_name: "",
          last_name: "",
          company_name: "",
          phone: "",
          country: "",
          url: "",
          email: "",
          emails: [],
          comments: "",
        },
        schemaStatus: {
          fields: [
            {
              type: "input",
              inputType: "text",
              styleClasses: "col-md-6",
              model: "first_name",
              featured: true,
              required: true,
              label: this.$t("lang.label.firstname"),
              max: 50,
              validator: VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
            },
            {
              type: "input",
              inputType: "text",
              styleClasses: "col-md-6",
              model: "last_name",
              featured: true,
              required: true,
              label: this.$t("lang.label.lastname"),
              max: 50,
              validator: VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
            },
            {
              type: "input",
              inputType: "text",
              styleClasses: "col-md-6",
              model: "company_name",
              featured: true,
              required: true,
              label: this.$t("lang.label.companyname"),
              min: 5,
              max: 50,
              validator: VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
                textTooSmall: this.$t("lang.validation.texttosmall", {
                  min: "{1}",
                }),
              }),
            },
            // {
            //   type: "autocomplete", 
            //   styleClasses: "col-md-6",
            //   label: "Country",
            //   model: "country",
            //   placeholder: "Select a country...",
            //   required: false,
            //   featured: true,
            //   multiple: false,
            //   values: [],
            //   onSearch: async (searchTerm, callback) => {
            //     if(this.countries.length > 0){
            //       const filtered = this.countryNames.filter( country =>
            //         country.toLowerCase().includes(searchTerm.toLowerCase())
            //       );
            //       callback(filtered); 
            //     }
                
            //   },
            // },
            {
              type: "phone",
              styleClasses: "col-md-6",
              model: "phone",
              min: 8,
              featured: true,
              required: true,
              label: this.$t("lang.label.mobile_phone"),
              validator: VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
                textTooSmall: this.$t("lang.validation.texttosmall", {
                  min: "{1}",
                }),
              }),
              fieldOptions: {
                dynamicPhoneValue: null,
                syncFromContact: true,
              },
            },
            {
              type: "input",
              inputType: "url",
              styleClasses: "col-md-12",
              label: this.$t("lang.label.website"),
              model: "url",
              id: "url",
              featured: true,
              required: true,
              validator: VueFormGenerator.validators.required,
            },
            {
              type: "input",
              inputType: "email",
              styleClasses: "col-md-12",
              label: this.$t("lang.column.email"),
              model: "email",
              id: "email",
              featured: true,
              required: true,
              validator: VueFormGenerator.validators.email,
            },
            {
              type: "vueMultiSelect",
              model: "emails",
              styleClasses: "col-md-12 em",
              label: "<b>" + this.$t("lang.label.otherguests") + "</b>",
              id: "emails",
              values: [],
              required: false,
              multiSelect: true,
              placeholder: this.$t("lang.calendar.addOtherguests"),//"Add your invitees e-mail here (ex:john.doe@company.com)",
              selectOptions: {
                onSearch: (value) => {
                  let isEmailValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
  
                  if (isEmailValid.test(value) && value.length > 6) {
                    this.emailTagPlaceholder.selectOptions.tagPlaceholder = this.$t("lang.calendar.addGuestToList")//'Press enter to add this e-mail to the list';
                  } else {
                    this.emailTagPlaceholder.selectOptions.tagPlaceholder = this.$t("lang.calendar.emailValid")//'Enter email valido';
                  }
                },
                multiple: true,
                trackBy: "value",
                label: "name",
                taggable: true,
                searchable: true,
                closeOnSelect: true,
                hideSelected: true,
                tagPlaceholder: this.$t("lang.calendar.emailValid"),
                //validator: VueFormGenerator.validators.email,
                onNewTag(newTag, id, options, value) {
                  const isEmailValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
  
                  const currentValues = value.map( el => el.value);
  
                  if (isEmailValid.test(newTag) && !currentValues.includes(newTag)) {
                    const tag = {
                        name: newTag,
                        icon: "none",
                        custom: true,
                        value: newTag,
                      };
                    value.push(tag);
                  }
                },
              },
            },
            {
              type: "textArea",
              styleClasses: "col-md-12",
              label: this.$t("lang.label.comments"),
              model: "comments",
              featured: true,
              hint: this.$t("lang.label.max500characters"),
              max: 500,
              rows: 2
            },
          ],
        },
        formOptions: {
          validateAfterLoad: false,
          validateAfterChanged: false,
        },
        calendarFormKey: 0,
        hourly: false,
        emailTagPlaceholder: null,
      };
    },
    props: {
      calendar: Object,
      timezones: Array,
      monthlabel: String,
      businessName: String,
      bc_hash:String,
      isUserBdr: Boolean,
      currentBusinessContact: null,
      responder: null,
      useResponder: Boolean,
      addOtherGuest: Boolean
    },
    components: {
      CalendarHourly,
      "vue-form-generator": VueFormGenerator.component,
      Modal,
      Day
    },
    watch: {
    calendar: {
    immediate: true,
    deep: true,
    handler(newCalendar, oldCalendar) {
      console.log("calendar actualizado:", newCalendar);      
    }
  },
      'modelform.country': function (newVal, oldVal) {
          if( this.countries.length > 0){
            const country = this.countries.find( el => el.name == newVal)
           if(country && country.phone_code && country.iso) {
              this.modelform.phone = "+"+ country.phone_code
              this.setPhoneCountryIso(country.iso);
            }         
          }    
      },
      currentBusinessContact(newValue) {
        if (!newValue) {
          return;
        }
        this.applyContactToForm(newValue);
      },
      responder() {
        this.applyInviteeToForm();
      },
      useResponder() {
        this.applyInviteeToForm();
      },
      addOtherGuest() {
        this.applyInviteeToForm();
      }
    },
    created() {
        this.$store.dispatch("optionsList/getProfileCountries").then(() => {
          this.countryNames = this.Countries.map(el => el.name);
  
          const countryField = this.schemaStatus.fields.find(
            (field) => field.model === "country"
          );
          if (countryField) {
            countryField.values = [...this.countryNames];
          }
          this.countries = this.Countries;

          if (this.currentBusinessContact) {
            this.applyContactToForm(this.currentBusinessContact);
          }
        });
        console.log(""+this.timezone)
        console.log(this.calendar)
        
        if(!this.timezone){
          
        if(this.calendar.timezone === undefined && !this.isUserBdr){
          let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // console.log("esto es tz?",tz)
        let dataZone = tz.split("/");
        this.timezones.forEach((item) => {
              if (item.label.includes(dataZone[1])) {
                this.timezone = item.id;
                this.calendar.timezone = item.id
              }
            });
        }
        else{
          this.timezone = this.calendar.defaultTimezone;
        }
      }
      
        const textToHash = "oliverlististhebest"+ Math.floor(Math.random() * 100) + 1;
        this.myhsdefault = textToHash;
        // Convertir la cadena a bytes
        const bytes = new TextEncoder().encode(textToHash);
        // Aplicar SHA-256
        window.crypto.subtle.digest('SHA-1', bytes).then(hashBuffer => {
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
  
          // Mostrar el hash en hexadecimal
          this.myhs = hashHex;
          console.log(this.myhs)
        }).catch(error => {
          console.log("CATCH?")
          console.log(error)
        });

      if (typeof this.$route.params.campaign_hash !== "undefined") {
        this.campaign_hash = this.$route.params.campaign_hash
        this.campaign_hash = this.campaign_hash.replace(/=3D/g, "%3D");
        this.campaign_hash = this.campaign_hash.replace("%20","");
        this.campaign_hash = decodeURIComponent(this.campaign_hash);
        this.campaign_hash = this.campaign_hash.replace("  ","");
        this.campaign_hash = this.campaign_hash.replace(" ","");
        this.campaign_hash = this.campaign_hash.replace("=","");
      }
      if (typeof this.$route.params.business_contact_hash !== "undefined") {
        this.business_contact_hash = this.$route.params.business_contact_hash
        this.business_contact_hash = this.business_contact_hash.replace("%20","");
        this.business_contact_hash = this.business_contact_hash.replace(/=3D/g, "%3D");
        this.business_contact_hash = decodeURIComponent(this.business_contact_hash);
        this.business_contact_hash = this.business_contact_hash.replace("  ","");
        this.business_contact_hash = this.business_contact_hash.replace(" ","");
        this.business_contact_hash = this.business_contact_hash.replace("=","");
      }
  
  
  
    },
    mounted() {
  
      if (this.calendar.days.length > 0) {
        this.calendar.days.forEach((k, r) => {
          if (k == 0 && r < 15) {
            this.nodays++;
          }
          if (k > 1) {
            this.slotsAvailable = true;
          }
        });
        if (!this.slotsAvailable){
          this.$modal.show("noSlotsAvailable");
        }
      }
      this.emailTagPlaceholder = this.schemaStatus.fields.find( e => e.type === 'vueMultiSelect' && e.id === 'emails')
    },
    computed: {
      ...mapState({
        Countries: (state) => state.optionsList.all["profile_countries"].data,
      }),

      currntUserId() {
        return this.$store.state.authentication.user != undefined
          ? this.$store.state.authentication.user.id
          : 0;
      },
      textPlaceholderInvites(){
        if(this.isEmail){
          return "valido....."
        } else {
          return " no valido..."
        }
      }
    },
    methods: {
      setPhoneCountryIso(iso) {
        const phoneField = this.schemaStatus.fields.find((el) => el.type === "phone");
        if (phoneField && iso) {
          phoneField.fieldOptions.dynamicPhoneValue = String(iso).toLowerCase();
        }
      },
      getUrlFromDomain(domain) {
        if (!domain) {
          return "";
        }
        const trimmed = String(domain).trim();
        if (!trimmed) {
          return "";
        }
        if (/^https?:\/\//i.test(trimmed)) {
          return trimmed;
        }
        return `https://${trimmed}`;
      },
      formatPhoneForContact(phone) {
        if (!phone) {
          return { phone: "", countryIso: null };
        }

        const normalized = String(phone).trim();
        if (!normalized.startsWith("+") || !this.countries.length) {
          return { phone: normalized, countryIso: null };
        }

        const sortedCountries = [...this.countries].sort(
          (a, b) => String(b.phone_code).length - String(a.phone_code).length
        );
        const allDigits = normalized.replace(/[^\d]/g, "");

        for (const country of sortedCountries) {
          const code = String(country.phone_code);
          if (!allDigits.startsWith(code)) {
            continue;
          }

          const nationalPart = normalized
            .slice(normalized.indexOf("+") + 1 + code.length)
            .replace(/^[\s-]+/, "")
            .replace(/[^\d-]/g, "");

          return {
            phone: nationalPart ? `+${code} -${nationalPart}` : `+${code} `,
            countryIso: country.iso ? String(country.iso).toLowerCase() : null,
          };
        }

        return { phone: normalized, countryIso: null };
      },
      normalizeEmail(email) {
        return String(email || "").trim().toLowerCase();
      },
      buildInviteeIdentity(contact) {
        const nameParts = (contact.name || "").trim().split(/\s+/);
        let invitee = {
          first_name: contact.first_name || nameParts[0] || "",
          last_name: contact.last_name || nameParts.slice(1).join(" ") || "",
          phone: contact.phone,
          email: contact.email || "",
        };

        if (this.useResponder && this.responder) {
          const responder = this.responder;
          const responderNameParts = (responder.name || "").trim().split(/\s+/);
          const hasResponderContact = !!(responder.first_name || responder.last_name || responder.name);
          invitee = {
            first_name: hasResponderContact
              ? responder.first_name || responderNameParts[0] || ""
              : responder.same_person ? invitee.first_name : "",
            last_name: hasResponderContact
              ? responder.last_name || responderNameParts.slice(1).join(" ") || ""
              : responder.same_person ? invitee.last_name : "",
            phone: responder.phone || "",
            email: responder.email,
          };
        }

        const { phone, countryIso } = this.formatPhoneForContact(invitee.phone);

        if (countryIso) {
          this.setPhoneCountryIso(countryIso);
        }

        return {
          first_name: invitee.first_name,
          last_name: invitee.last_name,
          phone,
          email: invitee.email,
        };
      },
      buildGuestEmails(currentEmails, contact) {
        if (!this.responder) {
          return currentEmails || [];
        }
        const managedEmails = [contact.email, this.responder.email].map((email) => this.normalizeEmail(email));
        const emails = (currentEmails || []).filter((el) => !managedEmails.includes(this.normalizeEmail(el.value)));
        const otherEmail = this.useResponder ? contact.email : this.responder.email;

        if (this.addOtherGuest && otherEmail) {
          emails.push({
            name: otherEmail,
            icon: "none",
            custom: true,
            value: otherEmail,
          });
        }
        return emails;
      },
      buildModelformFromContact(contact) {
        return {
          ...this.buildInviteeIdentity(contact),
          company_name: this.businessName,
          country: "",
          url: this.getUrlFromDomain(contact.domain),
          emails: this.buildGuestEmails([], contact),
          comments: "",
        };
      },
      applyContactToForm(contact) {
        if (!contact) {
          return;
        }
        this.modelform = this.buildModelformFromContact(contact);
        this.calendarFormKey += 1;
      },
      applyInviteeToForm() {
        const contact = this.currentBusinessContact;
        if (!contact) {
          return;
        }
        this.modelform = {
          ...this.modelform,
          ...this.buildInviteeIdentity(contact),
          emails: this.buildGuestEmails(this.modelform.emails, contact),
        };
        this.calendarFormKey += 1;
      },
      goToNextMonth(){
        this.$modal.hide("noSlotsAvailable")
        this.slotsAvailable = false
  
        if(this.campaign_hash){
          myCalendarService.insertActivity(this.campaign_hash,this.business_contact_hash, true, 'No-Slot Next Month: ' + this.calendar.currentyear + '/'+this.calendar.currentmonth);
        }
  
        this.$emit('nextMonth')
  
      },
      showDay(day) {
  
        if(day == 'empty'){
          this.loadingHourly = false;
           this.hourly = [];
           return
        }
  
        if(!this.myhs){
          this.myhs = this.myhsdefault
        }
        this.loadingHourly = true;
        this.day = day;
        myCalendarService
          .getAvailabilityByDay(
            day,
            this.calendar.currentmonth,
            this.calendar.currentyear,
            this.calendar.accountId,
            this.calendar.timezone,
            this.myhs
          )
          .then((res) => {
            this.loadingHourly = false;
            this.hourly = res;
          });
        this.$emit("showday", this.day);
  
      if(this.campaign_hash){
        myCalendarService.insertActivity(this.campaign_hash,this.business_contact_hash, true, 'Day: ' + this.calendar.currentyear + '/'+this.calendar.currentmonth+'/'+this.day);
      }
  
      },
      selectTimeZone() {
        this.$emit("timezone", this.timezone);
      },
      openForm(hour) {
        if (this.currentBusinessContact && this.countries.length) {
          this.applyContactToForm(this.currentBusinessContact);
        }
        this.open = true;
        this.hourchoose = hour;
        let day = [
          this.day,
          this.calendar.currentmonth,
          this.calendar.currentyear,
          hour,
        ];
        this.$emit("open", day);
  
        if(this.campaign_hash){
        myCalendarService.insertActivity(this.campaign_hash,this.business_contact_hash, true, 'Hour: ' + this.calendar.currentyear + '/'+this.calendar.currentmonth+'/'+this.day+' '+hour);
        }
      },
      createEvent() {
        // this.$refs.schemaStatusV.validate();
        // if (this.$refs.schemaStatusV.errors.length > 0) {
        //   return false;
        // }
  
  
        // if(!this.myhs){
        //   this.myhs = this.myhsdefault
        // }
  
        //if (this.modelform.phone.length < 6) this.modelform.phone = ""
  
        let data = {
          modelform: this.modelform,
          account_id: this.calendar.accountId,
          day: this.day,
          month: this.calendar.currentmonth,
          year: this.calendar.currentyear,
          hour: this.hourchoose,
          business_contact_hash: this.bc_hash,
          campaign_hash: this.campaign_hash,
          timezone_id: this.timezone,
          bdr_user_id: this.currntUserId,
          s: this.myhs
        };
        this.$emit("eventcreated", this.modelform);
        this.$emit("createEvent",data);
      },
      addEmail(email) {
        this.modelform.emails.push(email);
      },
    },
    
  };
  
  </script>
  
  
  <style scoped>
  >>> .multiselect__placeholder {
    font-style: italic;
    font-size: 14px;
  }
  >>> .multiselect__tags input placeholder {
    font-style: italic;
    font-size: 3px;
  }
  
  >>> .multiselect__input {
    font-style: italic;
    font-size: 14px;
  }
  </style>
